// Configuration file for environment-specific variables

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'; 